import combineProductNames from '../../../../utils/combine-product-names';

const getProductName = (product: any, softBundleComplementaryProduct: any) => {
  const { shortName } = product;

  if (softBundleComplementaryProduct) {
    return combineProductNames(product, softBundleComplementaryProduct);
  }

  return shortName;
};

export default getProductName;
